import {
  FETCH_HISTORYLIST_REQUEST,
  FETCH_HISTORYLIST_SUCCESS,
  FETCH_HISTORYLIST_FAILURE,
} from "./historyListTypes";

const initialState = {
  loading: false,
  historyList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HISTORYLIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_HISTORYLIST_SUCCESS:
      return {
        loading: false,
        historyList: action.payload,
        error: "",
      };
    case FETCH_HISTORYLIST_FAILURE:
      return {
        loading: false,
        historyList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
